// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationCompleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_RevenueConciliationCompleteResponseDados {
status: number
status_label: string
amount: number
value_in_cents: number
count: number
}

export type Payroll_RevenueConciliationCompleteResponse = ApiResponse<Payroll_RevenueConciliationCompleteResponseDados>;

registerResponseContract('Payroll_RevenueConciliationCompleteResponse', {
  status:         { type: 'number',  required: true },
  status_label:   { type: 'string',  required: true },
  amount:         { type: 'number',  required: true },
  value_in_cents: { type: 'number',  required: true },
  count:          { type: 'number',  required: true },
})
